import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthTrackingService } from '@core/services/authTracking.service';
import { Constants } from '@app/core/constants/core.constants';
import { UtilitiesService } from '@core/services';

@Injectable()
export class AuthenticationGuard implements CanActivate {

  constructor(
    private router: Router,
    private authTrackingService: AuthTrackingService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authTrackingService.isLoggedIn()) {
        // logged in so return true
        return true;
    }
    this.router.navigate(['/home'], { queryParams:
       UtilitiesService.generateQueryParams([Constants.SIGNIN,Constants.RETURN_URL], [true, state.url])});
    return false;
  }
}
